import { SVGIconProps } from './types'

export const STARTIcon = ({ style, ...props }: SVGIconProps) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ color: 'var(--color-accent)', ...style }}
      {...props}
    >
      <path
        d="M4.06203 10H22L19.8909 14.6667H2L4.06203 10Z"
        fill="currentColor"
      />
    </svg>
  )
}
